<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="!hasJoDetail()" class="flex flex-row gap-3 mt-3">
    <button (click)="lookupProduct()" pButton type="button" class="p-button-raised">Select Product</button>
    <div class="mt-2"><small *ngIf="poDetail.productId === 0" class="error-hint">A Product must be specified</small></div>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Manufacturer" class="w-5/12">
      <input [ngModel]="poHeader.manufacturer.name" disabled pInputText />
    </uni-field>
    <uni-field label="Account - (for account-owned inventory)" class="w-1/2">
      <input [ngModel]="poDetail.account?.accountName" disabled pInputText />
    </uni-field>

    <button (click)="lookupAccount()" [disabled]="hasJoDetail()" pButton type="button" class="p-button-raised">Select Account</button>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Description" class="w-7/12">
      <input [ngModel]="poDetail.product?.productType.description" disabled pInputText />
    </uni-field>
    <uni-field label="SKU" class="w-5/12">
      <input [ngModel]="poDetail.product?.productType.style" disabled pInputText />
    </uni-field>
  </div>

  <div *ngIf="poDetail.manufacturerProductTypeConfigId != null" class="flex flex-row gap-3 mt-3">
    <uni-field label="Manufacturer Description" class="w-7/12">
      <input [ngModel]="poDetail.manufacturerProductTypeConfig.configDescription" disabled pInputText />
    </uni-field>
    <uni-field label="Manufacturer SKU" class="w-5/12">
      <input [ngModel]="poDetail.manufacturerProductTypeConfig.configName" disabled pInputText />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Features" class="w-11/12">
      <input [ngModel]="poDetail.product?.featureChoicesExtract" disabled pInputText />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Qty" class="w-1/6">
      <input [(ngModel)]="poDetail.orderQty" [disabled]="hasJoDetail()" pInputText aria-describedby="orderQty" />
      <!-- <small id="orderQty" class="error-hint" *ngIf="getErrorMessage('orderQty')">{{ getErrorMessage('orderQty') }}</small> -->
    </uni-field>
    <uni-field label="Expected Date" class="w-5/12">
      <p-datepicker [(ngModel)]="poDetail.expectedShipDate" aria-describedby="expectedDate" appendTo="body"></p-datepicker>
      <!-- <small id="expectedDate" class="error-hint" *ngIf="getErrorMessage('expectedDate')">{{ getErrorMessage('expectedDate') }}</small> -->
    </uni-field>
    <uni-field label="Order Type" class="w-5/12">
      <p-dropdown
        [options]="poDetailTypes"
        [(ngModel)]="poDetail.poDetailTypeId"
        [disabled]="hasJoDetail()"
        optionValue="id"
        optionLabel="name"
      />
    </uni-field>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-2">
    <button (click)="save()" pButton type="button" class="p-button-raised">Save</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
